// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"d71eb1b5","848":"77ab775b","858":"1a50f7bb","916":"00427703","998":"77ab775b"}[chunkId] + ".chunk.css";
};